import React, { Component } from 'react'
import equal from 'fast-deep-equal';

export class DealerMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dealers: null,
        }        

        this.mapContainer = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if(!equal(this.props, prevProps)){
            this.setState({dealers: this.props.dealers} , () => {
                this.initMap(this.dealers);
            });
        }
    }

    initMap() {
        if(!this.state.dealers)
            return;        

        const {lat,lon,zoom, pro_dealer} = this.props.mapData;

        let locations = [];
        let locationInfo = [];
        let pro_dealers = [];
        this.state.dealers.map((dealer, index) => {
            locations.push([dealer.lat, dealer.lon]);
            locationInfo.push(`
            <h4>${dealer.name}</h4>
            <p>${dealer.adres}</p>
            <br>
            <a href="tel:${dealer.tel}">${dealer.tel}</a><br>
            <a href="mailto:${dealer.mail}">${dealer.mail}</a><br>
            <a href="${dealer.web}">${dealer.web}</a>
            `)
            pro_dealers.push(dealer.pro_dealer);
        });        

        var map = new google.maps.Map(this.mapContainer.current, {
            zoom: Number(zoom),
            center: new google.maps.LatLng(Number(lat), Number(lon)),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#bdbdbd"
                    }]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#ffbda4"
                    }]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "color": "#ffbda4"
                    }]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#eeeeee"
                    }]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e5e5e5"
                    }]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#ffffff"
                    }]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#dadada"
                    }]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                },
                {
                    "featureType": "road.local",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e5e5e5"
                    }]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#eeeeee"
                    }]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#c9c9c9"
                    }]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                }
            ]
        });

        
    
        var infowindow = new google.maps.InfoWindow();
        var marker, i;
    
        for (i = 0; i < locations.length; i++) {

            var icon = "/wp-content/themes/FirstBase/img/gMapsMarker.png";
            var indexValue = 2;

            if (pro_dealers[i]) {
                icon = "/wp-content/themes/FirstBase/img/gMapsMarkerPro.png";
                indexValue = 1;            
            }

            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i][0], locations[i][1]),
                icon: icon,
                map: map,
                zIndex: indexValue
            });
    
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent(locationInfo[i]);
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }
    
    }

    render() {
        return (
            <div id="map" className="fb_map" ref={this.mapContainer} />
        )
    }
}

export default DealerMap
